
export enum Role {
  ADMIN = 'ADMIN',
  AFFILIATE = 'AFFILIATE',
  USER = 'USER',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
}

export enum UserTier {
  LEVEL_1 = 1, 
  LEVEL_2 = 2, 
  LEVEL_3 = 3, 
}

export interface WalletInfo {
  network: string;
  walletAddress: string;
}

export interface DailyStat {
    clicks: number;
    sales: number;
}

export interface User {
  id: string;
  name: string;
  email: string;
  phone?: string;
  telegramId?: string;
  tradingViewId?: string;
  role: Role;
  avatar: string;
  status: 'ACTIVE' | 'BANNED' | 'PENDING' | 'EXPIRED';
  
  registerDate: string;
  registerIP: string;
  lastLogin: string;
  password?: string; 

  referralCode: string;
  referredBy?: string; // Sẽ lưu TradingView ID của người giới thiệu
  
  groupId: number; // 1-8
  isGroupLeader?: boolean;
  voteRank?: number; // 1, 2, 3 for bonuses

  clickCount: number;
  totalReferrals: number;
  totalSales: number; 
  
  incomeWallet: number; 
  rewardWallet: number; 

  subscriptionExpiry: string;
  totalMonthsPaid: number;
  currentTier: UserTier;

  dailyStats?: Record<string, DailyStat>;
  walletDetails?: WalletInfo;
}

export interface SystemSettings {
  general: {
    siteName: string;
    cookieDuration: number;
    attributionModel: 'LAST_CLICK' | 'FIRST_CLICK';
  };
  commission: {
    // T Commissions (Direct)
    t1_amount: number; // Level 1 Direct
    t2_amount: number; // Level 2 Direct
    t3_amount: number; // Level 3 Direct
    // K Commissions (System/Indirect)
    k1_amount: number; // Level 1 Indirect
    k2_amount: number; // Level 2 Indirect
    k3_amount: number; // Level 3 Indirect
  };
  payout: {
    minWithdrawal: number;
    holdDays: number;
    payoutDates: string;
  };
}

export interface AffiliateStats {
  clicks: number;
  sales: number;
  conversionRate: number;
  totalRevenue: number;
  pendingCommission: number;
  incomeBalance: number;
  rewardBalance: number;
  paidCommission: number;
  currentTier: UserTier;
  groupId: number;
}

export interface Transaction {
  id: string;
  date: string;
  customerName: string;
  customerId?: string;
  affiliateId?: string; 
  amount: number;
  commission: number; 
  indirectCommission?: number; 
  groupBonus?: number;
  status: TransactionStatus;
  product: string;
  packageMonths: number;
}

export interface PayoutRequest {
  id: string;
  affiliateName: string;
  affiliateId: string;
  date: string;
  amount: number;
  status: TransactionStatus;
  walletAddress: string;
}

export interface MarketingAsset {
  id: string;
  title: string;
  type: 'BANNER' | 'TEXT' | 'EMAIL';
  content: string;
  preview?: string;
}

export const PACKAGES = [
    { id: '1M', name: 'Gói 1 Tháng', price: 100, months: 1, bonusMonths: 0, isDefault: true },
    { id: '3M', name: 'Gói 3 Tháng', price: 300, months: 3, bonusMonths: 0, isDefault: false },
    { id: '6M', name: 'Gói 6 Tháng', price: 600, months: 6, bonusMonths: 0, isDefault: false },
    { id: '12M', name: 'Gói 1 Năm', price: 1200, months: 12, bonusMonths: 0, isDefault: false },
];
